/**
 * GlobalToastHost — renderiza los toasts emitidos por `emitToast()`.
 *
 * Se monta una sola vez, arriba del árbol. Su razón de ser es que una mutación
 * que falla sin `onError` propio muestre igual el mensaje del backend, en vez de
 * quedarse en silencio (incidente 2026-07-28: el DELETE de un bono devolvía 403
 * y el usuario no veía nada).
 */
import { useCallback, useEffect, useState } from 'react'
import { ToastContainer, type ToastMessage, type ToastType } from '@/components/Toast'
import { subscribeToasts } from '@/lib/globalToast'

let _nextId = 1

export function GlobalToastHost() {
  const [toasts, setToasts] = useState<ToastMessage[]>([])

  useEffect(() => subscribeToasts((type: ToastType, message: string) => {
    setToasts(prev => {
      // Evita apilar el mismo mensaje si el usuario repite el clic.
      if (prev.some(t => t.message === message)) return prev
      return [...prev, { id: _nextId++, type, message }]
    })
  }), [])

  // Estable: `ToastItem` reinicia su temporizador si cambia `onDismiss`, y con
  // una función nueva en cada render cada toast nuevo alargaba los anteriores.
  const dismiss = useCallback((id: number) => setToasts(prev => prev.filter(t => t.id !== id)), [])

  return <ToastContainer toasts={toasts} onDismiss={dismiss} />
}
